import { Box, Stack, Tab, Tabs } from '@mui/material';
import { type SyntheticEvent, useState } from 'react';
import { PlansTab } from 'src/pages/Settings/memberships/components/plans-tab/plans-tab';
import { StyleTab } from 'src/pages/Settings/memberships/components/style-tab';
import { TabValues } from 'src/pages/Settings/memberships/types';

type TabValue = TabValues;

interface ConfigTabsProps {
  onTabChange?: (tabIndex: TabValue) => void;
  readOnly: boolean;
}

export const ConfigTabs = ({ onTabChange, readOnly }: ConfigTabsProps) => {
  const [activeTab, setActiveTab] = useState<TabValue>(TabValues.Plans);

  const handleTabChange = (_: SyntheticEvent, nextTab: TabValue) => {
    if (nextTab === activeTab) {
      return;
    }
    setActiveTab(nextTab);
    onTabChange?.(nextTab);
  };

  return (
    <Stack height="100%" flex={1} direction="column">
      <Tabs value={activeTab} onChange={handleTabChange} sx={{ px: 2 }}>
        <Tab label="Plans" value={TabValues.Plans} />
        <Tab label="Style" value={TabValues.Style} />
      </Tabs>

      <Box flex={1} overflow="auto" py={2}>
        {activeTab === TabValues.Plans ? <PlansTab readOnly={readOnly} /> : null}

        {activeTab === TabValues.Style ? <StyleTab readOnly={readOnly} /> : null}
      </Box>
    </Stack>
  );
};
